import React from 'react';
import { siteData } from '../data/mock';

const Infrastructure = () => {
  const { infrastructure } = siteData;
  
  return (
    <article className="space-y-14 sm:space-y-20">
      {/* Header */}
      <header className="space-y-5 sm:space-y-6">
        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-light text-[#1a1a1a] leading-snug sm:leading-tight tracking-tight">
          {infrastructure.title}
        </h1>
        <div className="space-y-4 text-[#2a2a2a] text-base leading-relaxed">
          {infrastructure.intro.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </header>
      
      {/* Why This Matters */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {infrastructure.whyMatters.title}
        </h2>
        <div className="space-y-4 text-[#2a2a2a] text-base leading-relaxed">
          {infrastructure.whyMatters.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </section>
      
      {/* Where We Operate */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {infrastructure.whereOperate.title}
        </h2>
        <ul className="space-y-2.5 sm:space-y-2 text-[#2a2a2a] text-base leading-relaxed">
          {infrastructure.whereOperate.points.map((point, i) => (
            <li key={i} className="flex">
              <span className="mr-3 text-[#999999] flex-shrink-0">•</span>
              <span>{point}</span>
            </li>
          ))}
        </ul>
      </section>
      
      {/* What We Do Not Do */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {infrastructure.whatWeDoNot.title}
        </h2>
        <ul className="space-y-2.5 sm:space-y-2 text-[#2a2a2a] text-base leading-relaxed">
          {infrastructure.whatWeDoNot.points.map((point, i) => (
            <li key={i} className="flex">
              <span className="mr-3 text-[#999999] flex-shrink-0">•</span>
              <span>{point}</span>
            </li>
          ))}
        </ul>
        <div className="space-y-4 text-[#2a2a2a] text-base leading-relaxed pt-3 sm:pt-4">
          {infrastructure.whatWeDoNot.closing.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </section>
      
      {/* Typical Contexts */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {infrastructure.typicalContexts.title}
        </h2>
        <ul className="space-y-2.5 sm:space-y-2 text-[#2a2a2a] text-base leading-relaxed">
          {infrastructure.typicalContexts.points.map((point, i) => (
            <li key={i} className="flex">
              <span className="mr-3 text-[#999999] flex-shrink-0">•</span>
              <span>{point}</span>
            </li>
          ))}
        </ul>
        <p className="text-[#2a2a2a] text-base leading-relaxed pt-3 sm:pt-4">
          {infrastructure.typicalContexts.closing}
        </p>
      </section>
      
      {/* Divider */}
      <div className="border-t border-[#E8E8E6]" />
      
      {/* Energy Infrastructure Section */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-light text-[#1a1a1a] leading-snug sm:leading-tight tracking-tight">
          {infrastructure.energy.title}
        </h2>
        <div className="space-y-4 text-[#2a2a2a] text-base leading-relaxed">
          {infrastructure.energy.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </section>
      
      {/* Contact */}
      <section className="space-y-4">
        <p className="text-[#2a2a2a] text-base leading-relaxed">
          {infrastructure.contact.label}{' '}
          <a 
            href={`mailto:${infrastructure.contact.email}`}
            className="underline underline-offset-4 decoration-[#cccccc] hover:decoration-[#1a1a1a] transition-colors break-all sm:break-normal"
          >
            {infrastructure.contact.email}
          </a>
        </p>
      </section>
    </article>
  );
};

export default Infrastructure;
